import { render, staticRenderFns } from "./SingleSession.vue?vue&type=template&id=0acbf020&scoped=true"
import script from "./SingleSession.vue?vue&type=script&lang=js"
export * from "./SingleSession.vue?vue&type=script&lang=js"
import style0 from "./SingleSession.vue?vue&type=style&index=0&id=0acbf020&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0acbf020",
  null
  
)

export default component.exports